import { render, staticRenderFns } from "./TotalSalariesForOneDepartment.vue?vue&type=template&id=1aa79ce6&"
import script from "./TotalSalariesForOneDepartment.vue?vue&type=script&lang=js&"
export * from "./TotalSalariesForOneDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports